export class AucunCreneauCourantException extends Error {
  constructor(message = 'Aucun créneau courant') {
    super(message);
    this.name = 'AucunCreneauCourantException';
  }
}
